export default __webpack_public_path__ + "static/media/blueprint.352cbbf9.svg";